import React from "react";
import "./Packages.css";
import { GiCooler } from "react-icons/gi";

const packages = [
  {
    route: "CAMRY CAR Service",
    price: "  AC          4 seats",
    img: "images/camry.png",
    details: [
      "Jeddah to Makkah 300 SR",
      "Madina to Ziarah 200 SR",
      "Jeddah to Madina 500 SR",
      "Makkah to Jeddah 250 SR",
      "Makkah to Madina 450 SR",
      "Madina to Jaddah 450 SR",
      "Madina Hotel to Madina Airport 150 SR",
      "Makkah to Jaddah Visit 600 SR",
      "Makkah to Taif Visit 500 SR",
      "Makkah to Ziarah 250 SR",
      "Per Hour Rate 80 SR",
    ],
  },
  {
    route: "HIACE - 2022 Model",
    price: "   AC          11 seats",
    img: "images/hiace.png",
    details: [
      "Jeddah to Madina 700 SR",
      "Jaddah to Makkah 400 SR",
      "Makkah to Madina 650 SR",
      "Madina to Jeddah 650 SR",
      "Makkah to Jaddah Visit 850 SR",
      "Makkah to Taif Visit 650 SR",
      "Madina Hotel to Madina Airport 300 SR",
      "Madina to Baddar Visit 600 SR",
      "Madina to Ziarat 300 SR",
      "Makkah to Ziarat 350 SR",
      "Per Hour Rate 150 SR",
    ],
  },
  //   {
  //     route: "STARIA 2022/23",
  //     price: "   AC          7seats",
  //     img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUjELq-uae8-3ccB-7MW_ef0F1co_FSYjc4Q&s",
  //     details: [
  //       " Jeddah to Makkah 500 SR",
  //       " Jeddah to Jeddah 350 SR",
  //       " Makkah to Jeddah 450 SR",
  //       " Makkah to Madina 900 SR",
  //       " Madina to Makkah 900 SR",
  //       "  Madina to Jeddah 900 SR",
  //       "  Madina Hotel to Madina Airport 350 SR",
  //       " Madina Airport to Madina Hotel 450 SR",
  //       " Makkah to Jeddah Visit 1100 SR",
  //       " Makkah to Taif Visit 900 SR",
  //       " Makkah to Ziarah 450 SR",
  //       "Madina to Ziarah 400 SR",
  //       " Madina to Badar Visit 850 SR",
  //       " Madina to Alula Visit 1500 SR",
  //       " Per Hour Rate 200 SR",
  //     ],
  //   },

  {
    route: "GMC Yukon XL 2016 To 2019 Model",
    price: "AC 7 Seats",
    img: "images/gmc.png",
    details: [
      "AC",
      "Jeddah to Madina 1000 SR",
      "Jaddah to Makkah 450 SR",
      "Makkah to Madina 900 SR",
      "Madina to Jeddah 900 SR",
      "Makkah to Jaddah Visit 1200 SR",
      "Makkah to Taif Visit 900 SR",
      "Madina Hotel to Madina Airport 350 SR",
      "Madina to Baddar Visit 1000 SR",
      "Madina to Ziarat 350 SR",
      "Makkah to Ziarat 400 SR",
      "Per Hour Rate 200 SR",
    ],
  },
  {
    route: "H1 HYUNDAI Service",
    price: "AC 7 seats",
    img: "images/h1.png",
    details: [
      "Jeddah to Madina 600 SR",
      "Jaddah to Makkah 350 SR",
      "Makkah to Madina 550 SR",
      "Madina to Jeddah 550 SR",
      "Makkah to Jaddah Visit 700 SR",
      "Makkah to Taif Visit 600 SR",
      "Madina Hotel to Madina Airport 250 SR",
      "Madina to Baddar Visit 550 SR",
      "Madina to Ziarat 250 SR",
      "Makkah to Ziarat 300 SR",
      "Per Hour Rate 100 SR",
    ],
  },
  {
    route: "COASTER Service",
    price: "   AC          17seats",
    img: "images/coaster.png",
    details: [
      "Jeddah to Madina 1000 SR",
      "Jaddah to Makkah 500 SR",
      "Makkah to Madina 900 SR",
      "Madina to Jeddah 900 SR",
      "Makkah to Jaddah Visit 1100 SR",
      "Makkah to Taif Visit 900 SR",
      "Madina Hotel to Madina Airport 450 SR",
      "Madina to Baddar Visit 850 SR",
      "Madina to Ziarat 400 SR",
      "Makkah to Ziarat 450 SR",
      "Per Hour Rate 200 SR",
    ],
  },
];

const handleClick = () => {
  const phoneNumber = "03291396691"; // Replace with your desired phone number
  const message = "Hello! I would like to book a service."; // Replace with your default message
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  window.open(whatsappUrl, "_blank"); // Opens WhatsApp in a new tab
};

const PackagesComponent = () => {
  return (
    <div className="packages-container">
      <h1 className="packages-heading">OUR PACKAGES</h1>
      <p className="packages-subheading">
        Choose a package for a smooth and comfortable ride.
      </p>
      <hr />
      <div className="packages-grid">
        {packages.map((pkg, index) => (
          <div className="package-card" key={index}>
            {/* Top Div */}
            <div className="package-top">
              <h3 className="package-route">{pkg.route}</h3>
              <img
                src={pkg.img} // Replace with actual image path
                alt=""
                className="package-image"
              />

              <p className="package-price">
                <GiCooler color="#2f8599" />
                {pkg.price}
              </p>
            </div>

            {/* Bottom Div */}
            <div className="package-bottom">
              <h4>Details:</h4>
              <ul className="package-details">
                {pkg.details.map((detail, idx) => (
                  <li key={idx}>{detail}</li>
                ))}
              </ul>
              <button className="book-now-button" onClick={handleClick}>
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackagesComponent;
